import type { SlideProps } from "@/engine/app/offsite-config";

export function Slide16OvernightAnkuendigung(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 460,
          height: 460,
          top: "-120px",
          left: "20%",
          background: "var(--svo-blau)",
          opacity: 0.32,
        }}
      />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 280,
          height: 280,
          bottom: "-60px",
          right: "10%",
          background: "var(--svo-gruen)",
          opacity: 0.12,
          animationDelay: "4s",
        }}
      />

      <header className="deck-head" style={{ textAlign: "center", margin: "0 auto" }}>
        <div className="deck-eyebrow rise rise-1">Live-Lauf</div>
      </header>

      <div className="deck-lead" style={{ margin: "0 auto", textAlign: "center", justifyItems: "center" }}>
        <div className="lead-statement rise rise-2">
          Eure Anforderungen gehen jetzt durch die KI.
        </div>
        <div className="lead-pill rise rise-3" style={{ alignSelf: "center" }}>
          Die KI baut – live, während wir weitermachen.
        </div>
        <div className="lead-body rise rise-4" style={{ textAlign: "center" }}>
          Am Ende der Präsentation seht ihr das Ergebnis.
        </div>
      </div>
    </div>
  );
}
